/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Total_Events_LabelInputs */

const en_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Events:`)
};

const fr_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des evenements :`)
};

const de_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzahl der Ereignisse:`)
};

const it_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi totali:`)
};

const ru_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего событий:`)
};

const es_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos:`)
};

const zh_cn2_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动总数：`)
};

const ja_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計イベント数:`)
};

const hi_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल आयोजन:`)
};

const pt_pt2_explorer_thumbnail_total_events_label = /** @type {(inputs: Explorer_Thumbnail_Total_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos:`)
};

/**
* | output |
* | --- |
* | "Total Events:" |
*
* @param {Explorer_Thumbnail_Total_Events_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_total_events_label = /** @type {((inputs?: Explorer_Thumbnail_Total_Events_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Total_Events_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_total_events_label(inputs)
	if (locale === "de") return de_explorer_thumbnail_total_events_label(inputs)
	if (locale === "it") return it_explorer_thumbnail_total_events_label(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_total_events_label(inputs)
	if (locale === "es") return es_explorer_thumbnail_total_events_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_total_events_label(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_total_events_label(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_total_events_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_total_events_label(inputs)
	return en_explorer_thumbnail_total_events_label(inputs)
});